export function Overlay() {
  return (
    <div className="absolute w-full h-full z-10 bg-white/50 top-0 left-0"></div>
  );
}
